'use client';

import { useSelectedLayoutSegments } from 'next/navigation';

import { PageTabs } from '../page-tabs';
import RewardHeader from '../reward-header';

interface PageTabsWrapperProps {
  isMobile: boolean;
}

const PageTabsWrapper: React.FC<PageTabsWrapperProps> = ({ isMobile }) => {
  const segment = useSelectedLayoutSegments()?.[1];

  switch (segment) {
    case 'my-reward':
      return <RewardHeader />;
    default:
      return <PageTabs isMobileInit={isMobile} />;
  }
};

export default PageTabsWrapper;
